// extracted by mini-css-extract-plugin
export var opacityAnime = "Square-module--opacityAnime--U8p3w";
export var square = "Square-module--square--gkImp";
export var square__icon = "Square-module--square__icon--O+c-x";